import * as odpUtils from '../integrations/ODP/utils';

const inputCollections = document.getElementById('collections-search');

//Show Reset Button for Search Form
if (inputCollections) {

    const clearSearch = document.getElementById('clear-search');
    const searchIcon = document.getElementById('searchIcon');

    clearSearch.addEventListener('click', function () {
        clearSearch.classList.remove('active');
        searchIcon.classList.add('active');
        inputCollections.value = '';
        document.getElementById('search-value').innerHTML = '';
    });

    inputCollections.onkeyup = function (e) {
        const key = e.keyCode || e.charCode;
        const clear = document.getElementById('clear-search');

        clearSearch.classList.add('active');
        searchIcon.classList.remove('active');

        if ((key == 8 || key == 46) && inputCollections.value.length == 0) {
            clear.classList.remove('active');
            searchIcon.classList.add('active');
        }
        //document.getElementById('search-value').innerHTML = inputCollections.value;
    };
}

class Search {
    Init() {
        var inst = this;
        $('.jsNavSearch').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.navSearch($(this));
            });
        });

        $('.jsCollectionSearch').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.collectionSearch($(this));
            });
        });
    }

    navSearch(e) {
        let form = $(e).closest("form")[0];
        let query = $("#nav-site-search").val();
        odpUtils.TrackSearch(query,"");
        window.location.href = encodeURI(form.action + '?q=' + query);
    }

    collectionSearch(e) {
        let form = $(e).closest("form")[0];
        let query = $("#collections-search", form).val();
        odpUtils.TrackSearch(query,"");
        window.location.href = encodeURI(form.action + '?q=' + query);
    }
}

var search = new Search();
search.Init();

let collectionsAccordions = document.querySelectorAll('.collections-accordion__accordion-trigger');
// Collections Accordions
if (collectionsAccordions !== null && collectionsAccordions !== undefined) {

    collectionsAccordions.forEach(function (accordions) {
        accordions.addEventListener("click", function () {
            let accordionContainer = this.closest('.collections-accordion__accordion-container');
            accordionContainer.classList.toggle('active');
        });
    });
}

const accordionContainerMobile = document.querySelectorAll('.collections-accordion__accordion-container');
// Removes active on mobile to close Accordions
if (accordionContainerMobile !== null && accordionContainerMobile !== undefined) {
    accordionContainerMobile.forEach(function (panel) {
        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if (viewportWidth < 768) {
            panel.classList.remove('active');
        }
    });
}

// Collections Tabs
const tabCollectionsCards = document.querySelectorAll('.collections-tabs__items');
if (tabCollectionsCards.length > 0) {
    const tabCollectionsContent = document.querySelectorAll('.collections-tabs__tab-panel-item');

    //Set the Results number below tabs

    tabCollectionsCards.forEach(function (card, index) {
        card.addEventListener('click', function (e) {
            e.preventDefault();

            let tabs = document.querySelectorAll('.collections-tabs__items');

            //Change the results number below tabs on click of tab
            //The below variables has to have a 2 so it can be found after click

            tabs.forEach(function (tab) {
                tab.classList.remove('active');
            });

            // add active to clicked element
            this.classList.add('active');

            let cardIndex = Array.from(card.parentNode.children).indexOf(card);

            tabCollectionsContent.forEach(function (content, index) {
                content.classList.remove('active');
            });

            tabCollectionsContent[cardIndex].classList.add('active');

            //clearPills.click();
            const accordionSet = document.querySelectorAll('.collections-accordion');
            accordionSet.forEach(function (set, index) {
                set.classList.remove('active');
            });
            accordionSet[index].classList.add('active');
        });
    });

    if (localStorage.getItem("SelectedTab") != null) {
        var selectedContent = localStorage.getItem("SelectedTab");
        var tabElement = $('li[data-id="' + selectedContent + '"]');
        if ($(tabElement).hasClass("active") == false) {
            $(".collections-tabs .collections-tabs__items[data-id='content-items']").click();
        }
        localStorage.removeItem("SelectedTab");
    }
}

const selectOptions = document.querySelectorAll('.product-sort');
const specTables = document.querySelectorAll('.product-detail-page__spec-table');

if (selectOptions.length > 0) {

    selectOptions.forEach(function (selectOption) {
        // Sort filter drop-down for search items
        if (selectOption !== null && selectOption !== undefined) {
            const optionBox = selectOption.querySelector('.product-sort__options');
            const options = selectOption.querySelectorAll('.product-sort__option-item');
            const selectedOption = selectOption.querySelector('.product-sort__selected-option');
            const defaultOption = selectOption.querySelector('.choose');
            selectedOption.innerText = defaultOption.innerText;

            options.forEach(option => {
                option.addEventListener('click', () => {
                    selectedOption.innerText = option.innerText;
                    optionBox.classList.toggle('active');
                    selectOption.classList.toggle('active');
                    showSpecification(option.dataset.code);
                });
            });

            selectOption.addEventListener('click', () => {
                optionBox.classList.toggle('active');
                selectOption.classList.toggle('active');
            });

            optionBox.addEventListener('mouseleave', function () {
                optionBox.classList.remove('active');
                selectOption.classList.remove('active');
            });
        }
    });
}

const filterBtnMobile = document.getElementById('filter-menu-mobile');
const filterMenu = document.querySelector('.collections-search-main-content__left');
const fixedClearMenu = document.querySelector('.clear-results-container');
// Opens filter menu on mobile
if (filterBtnMobile !== null && filterBtnMobile !== undefined) {

    filterBtnMobile.addEventListener('click', () => {
        filterMenu.classList.add('active');
        fixedClearMenu.classList.add('active');
    });
}

const clearCheckbox = document.getElementById('clear-results-mobile');
//const allCounts = document.querySelectorAll('.collections-accordion__items-checked');
const totalFilterCount = document.getElementById('total-filter-count');
let inputItem = document.querySelectorAll('.check:checked').length;

function showSpecification(code) {
    if (code !== null) {
        hideAllSpecificaitons();
        specTables.forEach(function (specTable) {
            let specCode = specTable.dataset.code;
            if (specCode === code) {
                specTable.classList.add('active');
            }
        });
    }
}

function hideAllSpecificaitons() {
    if (specTables.length > 0) {
        specTables.forEach(function (specTable) {
            specTable.classList.remove('active');
        });
    }
}

const mobileFilterMenuClose = document.querySelectorAll('.mobile-filter-menu-trigger');
// Closes filter menu on mobile
if (mobileFilterMenuClose !== null && mobileFilterMenuClose !== undefined) {
    mobileFilterMenuClose.forEach(function (closeItem) {
        closeItem.addEventListener('click', function (e) {
            e.preventDefault();
            filterMenu.classList.remove('active');
            fixedClearMenu.classList.remove('active');
            let test = document.querySelector('.total-filter-count');
            let test2 = document.querySelector('.filter-count-number');
            if (test2 != null) {
                test2.innerHTML = test.innerHTML;
            }
        });
    });
}

// Show Hide more Resource Category Options
const resourceCategoryItems = document.querySelectorAll('.resource-category__item');
const showResources = document.getElementById('show-resource-category');
const inactiveClass = 'inactive';
let maxResourceItems = 8;

[].forEach.call(resourceCategoryItems, function (resourceCategoryItems, index) {
    if (index > maxResourceItems - 1) {
        resourceCategoryItems.classList.add(inactiveClass);
    }
});

if (showResources) {
    showResources.addEventListener('click', function () {
        [].forEach.call(document.querySelectorAll('.' + inactiveClass), function (resourceItems, index) {
            resourceItems.classList.remove(inactiveClass);
            showResources.classList.add('inactive');
        });
    });
}